import { render, staticRenderFns } from "./MessageTextFormSave.vue?vue&type=template&id=3087c964&scoped=true&"
import script from "./MessageTextFormSave.vue?vue&type=script&lang=ts&"
export * from "./MessageTextFormSave.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTextFormSave.vue?vue&type=style&index=0&id=3087c964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3087c964",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
